import styled from 'styled-components';
import CommonButton from '../../components/atoms/Buttons/CommonBtn';

export const Container = styled.div<{theme?: any}>`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${({theme}) => theme.background};
  text-align: center;
`;

export const LogoContainer = styled.div`
  padding-top: 20px;
  margin-bottom: 40px;
`;

export const TitleContainer = styled.div`
  margin-bottom: 40px;
`;

export const Title = styled.text<{
  theme?: any;
}>`
  padding-top: 200px;
  font-weight: bold;
  font-size: 26px;
  color: ${({theme}) => theme.lightText};
`;

export const BottomContainer = styled.div<{theme?: any}>`
  height: 100%;
  background-color: ${({theme}) => theme.white};
  padding: 56px 23px 10px 23px;
  text-align: center;
`;

export const TextContainer = styled.div`
  text-align: left;
  margin-bottom: 10px;
`;

export const Text = styled.text<{theme?: any}>`
  font-weight: normal;
  font-size: 18px;
  color: ${({theme}) => theme.darkText};
  line-height: 30px;
`;

export const LineBreak = styled.div`
  margin-top: 10px;
`;

export const ButtonContainer = styled.div`
  margin-top: 10px;
  margin-bottom: 50px;
`;

export const TigoContaner = styled.div`
  margin-bottom: 30px;
`;

export const Button = styled(CommonButton)`
  width: 100%;
`;
